<template>
    <Modal
        v-model="isOpen"
        teleport-target="body"
        max-width="500px"
        backdrop-class="z-1000"
        wrapper-class="z-2000"
    >
        <template #default="{ close }">
            <div class="dim">
                <header class="dim__header">
                    <button type="button" class="dim__close-btn" @click="close">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            width="24"
                            height="24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </header>

                <div class="dim__content">
                    <div>
                        <img
                            src="https://upload.wikimedia.org/wikipedia/en/thumb/7/7a/Gemological_Institute_of_America_logo.svg/2560px-Gemological_Institute_of_America_logo.svg.png"
                            alt="GIA logo"
                            style="height: 20px"
                        />

                        <p
                            v-html="
                                $t('components.gia', {
                                    url: certificateUrl,
                                })
                            "
                        ></p>
                    </div>

                    <diamond-properties :diamond="selectedDiamond" />

                    <template v-if="videoLink && videoLink !== ''">
                        <iframe
                            v-show="showIFrame"
                            class="dim__iframe"
                            width="400"
                            height="400"
                            :src="videoLink"
                            style="border: none"
                            @load="handleIFrameLoaded"
                        ></iframe>

                        <div
                            v-show="!showIFrame"
                            class="dim__iframe"
                            style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                height: 370px;
                            "
                        >
                            <img
                                src="//cdn.shopify.com/s/files/1/0348/7101/7603/t/7/assets/loading.gif?v=2749976416133024973"
                                width="54"
                                height="54"
                                alt="Loading"
                            />
                        </div>
                    </template>
                    <template v-else>
                        <img
                            src="https://cdn.shopify.com/s/files/1/0348/7101/7603/files/Diamond_Platzhalter.png?v=1643889960"
                            width="400"
                            style="margin-top: 1rem"
                            alt="No Image"
                        />
                    </template>

                    <div style="margin-top: 16px;">
                        <DiamondColorDiagram />

                        <DiamondClarityDiagram />
                    </div>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import useStore from "@/composables/useStore";
import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
// eslint-disable-next-line
// @ts-ignore no TS types provided
import { Modal } from "vue-neat-modal";
import "vue-neat-modal/dist/vue-neat-modal.css";
import DiamondProperties from "@/components/DiamondProperties.vue";
import DiamondColorDiagram from "@/components/DiamondColorDiagram.vue";
import DiamondClarityDiagram from "@/components/DiamondClarityDiagram.vue";

export default defineComponent({
    name: "DiamondInfoModal",
    components: {
        DiamondClarityDiagram,
        DiamondColorDiagram,
        DiamondProperties,
        Modal,
    },
    setup() {
        const store = useStore();
        const isOpen = computed({
            get() {
                return store.state.showInfoModal;
            },

            set(value: boolean) {
                store.actions.setShowInfoModal(value);
            },
        });

        const showIFrame = ref(false);

        function handleIFrameLoaded() {
            showIFrame.value = true;
        }

        const selectedDiamond = computed(() => store.state.infoSelectedDiamond);

        const certificateUrl = computed(
            () => store.state.infoSelectedDiamond?.certificateLink
        );

        const carat = computed(() => store.state.infoSelectedDiamond?.carat);
        const shape = computed(() => store.state.infoSelectedDiamond?.shape);
        const clarity = computed(
            () => store.state.infoSelectedDiamond?.clarity
        );
        const color = computed(() => store.state.infoSelectedDiamond?.color);
        const cut = computed(() => store.state.infoSelectedDiamond?.cut);
        const videoLink = computed(
            () => store.state.infoSelectedDiamond?.videoLink
        );
        const productId = computed(() => store.state.infoSelectedDiamond?.sku);

        watch(videoLink, () => {
            showIFrame.value = false;
        });

        return {
            ...useI18n(),
            isOpen,
            selectedDiamond,
            certificateUrl,
            carat,
            shape,
            clarity,
            color,
            cut,
            videoLink,
            productId,
            showIFrame,
            handleIFrameLoaded,
        };
    },
});
</script>

<style>
.dim__iframe {
    width: 100%;
}
</style>
